"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "@/components/ThemeProvider";
import { WalletConnectProvider } from "@/components/WalletConnectProvider";

interface ProvidersProps {
  children: React.ReactNode;
}

// SessionProvider wraps WalletConnectProvider so the PrivyNextAuthBridge
// (mounted inside PrivyProvider) can call useSession() / signIn() to propagate
// Privy auth into a NextAuth session.
export function Providers({ children }: ProvidersProps) {
  return (
    <SessionProvider>
      <WalletConnectProvider>
        <ThemeProvider>
          {children}
        </ThemeProvider>
      </WalletConnectProvider>
    </SessionProvider>
  );
}
